import { toastShow } from '../ToastService';
import { sendEmail, sendEmailComunicado, sendEmailRequisa } from "./EmailRequest";



export const EnviarCorreo = async ({setLoadingCorreo, toast, showToas, contenido, to,  subject = '', cc = '', bcc = '', attachments = null} ) => {
    setLoadingCorreo(true);
    const objeto = {
        // to: "alberto_medina95@outlook.es",
        // cc: 'lmedina@ppf.com.hn',
        to: to,
        cc: cc,
        bcc: bcc,
        subject: subject,
        texto: contenido,
        attachments: attachments
    }
    const result = await sendEmail(objeto);
    if (result) {
        if(showToas){
            toastShow(toast, 'success', 'Correo enviado.');
        }
        setLoadingCorreo(false);
    } else {
        if(showToas){
        toastShow(toast, 'error', 'Correo no enviado.');
        }
        setLoadingCorreo(false);
    }
}

export const EnviarCorreoComunicado = async (setLoadingCorreo, toast, showToas, contenido, to,  subject = '', cc = '', bcc = '', attachments = null) => {
    setLoadingCorreo(true);
    console.log({attachments})
    const objeto = {
        // to: "alberto_medina95@outlook.es",
        // cc: 'lmedina@ppf.com.hn',
        to: to,
        cc: cc,
        bcc: bcc,
        subject: subject,
        texto: contenido,
        attachments: attachments
    }
    const result = await sendEmailComunicado(objeto);
    if (result) {
        if(showToas){
            toastShow(toast, 'success', 'Correo enviado.');
        }
        setLoadingCorreo(false);
    } else {
        if(showToas){
        toastShow(toast, 'error', 'Correo no enviado.');
        }
        setLoadingCorreo(false);
    }
}

export const EnviarCorreoFormatoLleno = async ({setLoadingCorreo, toast, showToas, contenido, to,  subject = '', cc = '', bcc = '', attachments = null} ) => {
    setLoadingCorreo(true);
    const objeto = {
        to: to,
        cc: cc,
        bcc: bcc,
        subject: subject,
        texto: contenido,
        attachments: attachments
    }
    const result = await sendEmail(objeto);
}


export const EnviarCorreoAprobacionR = async ({setLoadingCorreo, toast, showToas, contenido, to,  subject = '', cc = '', bcc = '', attachments = null} ) => {
    setLoadingCorreo(true);
    const objeto = {
        to: to,
        cc: cc,
        bcc: bcc,
        subject: subject,
        texto: contenido,
        attachments: attachments
    }
    const result = await sendEmailRequisa(objeto);
    if (result) {
        if(showToas){
            toastShow(toast, 'success', 'Correo enviado.');
        }
        setLoadingCorreo(false);
    } else {
        if(showToas){
        toastShow(toast, 'error', 'Correo no enviado.');
        }
        setLoadingCorreo(false);
    }
}


export const EnviarCorreoAsignacionR = async ({setLoadingCorreo, toast, showToas, to,  subject = '', cc = '', bcc = '', attachments = null, encabezado, detalles, mostrarToast} ) => {

    const formatDateTime = (dateTime) => {
        const date = new Date(dateTime);
        const formattedDate = date.toLocaleDateString();
        const formattedTime = date.toLocaleTimeString();
        return `${formattedDate} ${formattedTime}`;
      };

    if(encabezado && detalles){
        setLoadingCorreo(true);
        let contenido = 
        `
            <div style="font-family: Arial, sans-serif; line-height: 1.5;">
                <div style="margin-bottom: 10px;">
                    <span style="font-weight: bold;">Estimado(a): </span>${encabezado?.UserRequest?.UserName || encabezado?.UserRequest}
                </div>
                <div style="margin-bottom: 10px;">
                    <span style="font-weight: bold;">La Requisa No. </span>${encabezado?.PurchaseRequest}<span">, para el área de ${encabezado?.Area?.Area || encabezado?.Area} se encuentra asignada al agente de compras ${encabezado?.UserNameAgente?.UserNameAgente || encabezado?.UserNameAgente}</span>
                </div>
                <div style="margin-bottom: 10px;">
                    <span style="font-weight: bold;">Fecha de Solicitud: </span>${formatDateTime(new Date())}
                </div>

                <div style="margin-top: 20px;"></div>

                <!-- Tabla de detalles -->
                <table style="width: 80%; border-collapse: collapse; font-size: 14px; margin: 0 auto;">
                    <thead>
                        <tr>
                            <th style="border: 1px solid black; background-color: #bee9fc; padding: 8px;">Producto</th>
                            <th style="border: 1px solid black; background-color: #bee9fc; padding: 3px;">Código</th>
                            <th style="border: 1px solid black; background-color: #bee9fc; padding: 5px; width: 130px">Estado</th>
                            <th style="border: 1px solid black; background-color: #bee9fc; padding: 5px; width: 130px">Unidad</th>
                            <th style="border: 1px solid black; background-color: #bee9fc; padding: 5px; width: 100px;">Cantidad</th>
                            <th style="border: 1px solid black; background-color: #bee9fc; padding: 5px; width: 100px;">Precio</th>
                            <th style="border: 1px solid black; background-color: #bee9fc; padding: 5px; width: 100px;">ISV</th>
                            <th style="border: 1px solid black; background-color: #bee9fc; padding: 5px; width: 100px;">Total</th>
                        </tr>
                    </thead>
                    <tbody>
                        ${detalles.map(detalle => `
                        <tr>
                            <td style="border: 1px solid black; padding-left: 5px;">${detalle?.NombreProducto}</td>
                            <td style="border: 1px solid black; text-align: center;">${detalle?.CodigoProducto}</td>
                            <td style="border: 1px solid black; text-align: center;">${detalle?.StatusName}</td>
                            <td style="border: 1px solid black; text-align: center;">${detalle?.UnitName}</td>
                            <td style="border: 1px solid black; text-align: center; width: 100px;">
                            ${Number(detalle?.Quantity || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                            </td>
                            <td style="border: 1px solid black; text-align: center; width: 100px;">
                            ${Number(detalle?.Price || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                            </td>
                            <td style="border: 1px solid black; text-align: center; width: 100px;">
                            ${Number(detalle?.TAX || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                            </td>
                            <td style="border: 1px solid black; text-align: center; width: 100px;">
                            ${Number(detalle?.Total || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                            </td>

                        </tr>
                        `).join('')}
                    </tbody>
                </table>



            </div>
        `


    
        const objeto = {
            to: to,
            cc: cc,
            bcc: bcc,
            subject: subject,
            texto: contenido,
            attachments: attachments,
            mostrarToast: mostrarToast
        }

        // console.log(objeto)

    
        const result = await sendEmailRequisa(objeto);
        if(mostrarToast === 1){
            if (result) {
                if(showToas){
                    toastShow(toast, 'success', 'Correo enviado.');
                }
                setLoadingCorreo(false);
            } else {
                if(showToas){
                toastShow(toast, 'error', 'Correo no enviado.');
                }
                setLoadingCorreo(false);
            }
        }
    }
}